<template>
  <div class="loading-wrapper">
    <slot></slot>
    <div v-if="loading" class="loading-mask" :style="{ background }">
      <LoadingIcon :style="{ fontSize: size, color }" />
    </div>
  </div>
</template>

<script>
import LoadingIcon from './LoadingIcon.vue'
export default {
  name: 'Loading',
  components: {
    LoadingIcon
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '24px'
    },
    color: {
      type: String,
      default: '#939393'
    },
    background: {
      type: String,
      default: 'rgba(255, 255, 255, 0.4)'
    }
  }
}
</script>

<style scoped>
.loading-wrapper {
  position: relative;
}

.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
